// import { jsPDF } from "jspdf";
// import banner1 from "../../../Assets/ptags/banner.jpg";
// import { Url, getAdjustedPrice, generateBarcodeBase64 } from "../../../Services/Api";

// import "../../../Assets/ptags/fonts/Montserrat-Bold";
// import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
// import "../../../Assets/ptags/fonts/Montserrat-Black";
// import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
// import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
// import "../../../Assets/ptags/fonts/anton";



// const now = new Date();
// const timestamp = now
//     .toISOString()           // e.g., "2025-08-15T21:45:30.123Z"
//     .replace(/[:.]/g, '-')   // Replace colon and dot with dash
//     .replace('T', '_')       // Replace 'T' with underscore
//     .split('Z')[0];          // Remove trailing 'Z'


// export const generatePDFOpt2 = (sectionsCount, bannerImg,withBarCode) => {
//     const width = 816;
//     const height = 1056;
//     const doc = new jsPDF({
//         orientation: "portrait",
//         unit: "pt",
//         format: [width, height],
//     });

//     const sectionHeight = height / 2;
//     const sectionWidth = width;
//     const bannerImgHeight = 94;
//     const maxSectionsPerPage = 2;
//     let currentSection = 0;

//     while (currentSection < sectionsCount.length) {
//         if (currentSection > 0) doc.addPage();

//         const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

//         for (let i = 0; i < sectionsOnThisPage; i++) {
//             const sectionIndex = currentSection + i;
//             const yPos = i * sectionHeight;
//             const xPos = 2.5;

//             const section = sectionsCount[sectionIndex];
//             if (!section) continue;

//             const productImageUrl = section.image;
//             const name = section.name;
//             const sku = "Model#" + section.sku;
//             const variation = section.variations?.[0] || {};
//             const sale_price = variation.sale_price;
//             const regular_price = variation.regular_price;
//             const variation_value = variation.value;

//             const bannerImgWidth = width - 5;
//             doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

//             const sectionRectY = yPos + bannerImgHeight + 4.8;
//             const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);
//             const sectionRectX = xPos + 2.5;
//             const sectionRectWidth = width / 2.9;

//             doc.setLineWidth(2);
//             doc.setDrawColor(71, 74, 119);
//             doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

//             const sectionMainImageX = xPos + sectionRectWidth + 2.5;
//             const sectionMainImageWidth = width - (sectionRectWidth + 5);
//             const sectionMainImageHeight = 290;
//             if (productImageUrl) {
//                 doc.addImage(productImageUrl, "JPEG", sectionMainImageX + 5, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
//             }

//             doc.setFont("Montserrat-Bold", "bold");
//             doc.setTextColor(0, 0, 0);
//             doc.setFontSize(14);
//             const textX = sectionMainImageX + (sectionMainImageWidth - 15);
//             const textY = sectionRectY + 15;
//             doc.text(name, textX, textY, { align: 'right' });

//             doc.setFontSize(16);
//             doc.setFont("helvetica", "normal");
//             doc.text(sku, textX, textY + 20, { align: 'right' });

//             const lineY = sectionRectY + sectionRectHeight / 4;
//             doc.line(sectionRectX, lineY, sectionRectX + sectionRectWidth, lineY); //SEPARATION LINE IN WAS PRIOCE AN DVARIATIONS LIST

//             const subSection1Width = width / 2.9;
//             const wasPriceStartY = yPos;

//             doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//             doc.setTextColor(40, 142, 169);
//             doc.setFontSize(11);
//             const text1Width = doc.getTextWidth(variation_value);
//             const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
//             doc.text(variation_value, wasPriceStartX1, wasPriceStartY + 120);

//             const text2 = "was $" + regular_price;
//             doc.setTextColor(0, 0, 0);
//             doc.setFontSize(16);
//             const text2Width = doc.getTextWidth(text2);
//             const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
//             doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

//             const text3 = "$" + sale_price;
//             doc.setFont("Montserrat-Black", "normal");
//             doc.setTextColor(253, 0, 0);
//             doc.setFontSize(50);
//             const text3Width = doc.getTextWidth(text3);
//             const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
//             doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);

//             if (section.variations.length > 1) {
//                 doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//                 doc.setTextColor(0, 0, 0);
//                 doc.setFontSize(11);
//                 doc.text("Group Pricing", xPos + 10, lineY + 20);

//                 for (let v = 1; v < section.variations.length; v++) {
//                     const varItem = section.variations[v];
//                     const yOffset = lineY + 20 + v * 20;

//                     doc.setFontSize(8);
//                     doc.setTextColor(0, 0, 0);
//                     doc.text(varItem.value || "N/A", xPos + 10, yOffset);

//                     const valueWidth = doc.getTextWidth(varItem.value || "N/A");
//                     doc.setTextColor(253, 0, 0);
//                     doc.text(`$${varItem.sale_price || "0.00"}`, xPos + 10 + valueWidth + 5, yOffset);
//                 }
//             }

//             const gridRectX = xPos + (width / 1.49);
//             const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
//             const gridRectW = width / 3.1;
//             const gridRectH = sectionHeight / 3.75;

//             // doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');
//             doc.setLineWidth(2); // Ensure border is thick enough
//             doc.setDrawColor(71, 74, 119); // Same as left border color
//             doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');


//             const lineHeight = 15;
//             const verticalOffset = (gridRectH - (4 * lineHeight)) / 2;

//             const text1_main = "$" + getAdjustedPrice(sale_price).toString();
//             const text1_suffix = "/week";

//             doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//             doc.setFontSize(34);
//             const width_main = doc.getTextWidth(text1_main);
//             doc.setFont("helvetica", "normal");
//             doc.setFontSize(14);
//             const width_suffix = doc.getTextWidth(text1_suffix);
//             const totalWidth = width_main + width_suffix + 2;
//             const textX_g1 = gridRectX + (gridRectW / 2);
//             const textY_g1 = gridRectY + verticalOffset;
//             const combinedTextX = textX_g1 - (totalWidth / 2);

//             doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//             doc.setTextColor(253, 0, 0);
//             doc.setFontSize(34);
//             doc.text(text1_main, combinedTextX, textY_g1);
//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(61, 124, 157);
//             doc.setFontSize(18);
//             doc.text(text1_suffix, combinedTextX + width_main + 2, textY_g1);

//             doc.setFont("helvetica", "normal");
//             doc.setTextColor(151, 68, 131);
//             doc.setFontSize(13);
//             doc.text("Subject to approval. some restrictions apply", textX_g1, textY_g1 + lineHeight + 12, { align: 'center' });

//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(136, 194, 87);
//             doc.setFontSize(24);
//             doc.text("NO CREDIT 0 DOWN", textX_g1, textY_g1 + (3.5 * lineHeight) + 5, { align: 'center' });

//             doc.setFont("helvetica", "bold");
//             doc.setTextColor(56, 112, 151);
//             doc.setFontSize(18);
//             doc.text("100 DAYS NO INTEREST", textX_g1, textY_g1 + (5.5 * lineHeight) + 5, { align: 'center' });

//             const rightRectX = xPos + (width / 2.83);
//             const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
//             const rightRectW = width / 3.2;
//             const rightRectH = sectionHeight / 3.75;

//             doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');

//             const col1 = rightRectW * 0.3;
//             const col2 = rightRectW * 0.2;
//             const col3 = rightRectW * 0.3;
//             const col4 = rightRectW * 0.2;
//             const rowHeight = rightRectH / 4;

//             for (let r = 1; r < 5; r++) {
//                 const y = rightRectY + r * rowHeight;
//                 doc.line(rightRectX, y, rightRectX + rightRectW, y);
//             }

//             const colX1 = rightRectX + col1;
//             const colX2 = colX1 + col2;
//             const colX3 = colX2 + col3;
//             doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH);
//             doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH);
//             doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH);

//             const values = section.individuals || [];
//             const itemsPerRow = 2;
//             const totalRows = Math.ceil(values.length / itemsPerRow);

//             for (let r = 0; r < totalRows; r++) {
//                 const y = rightRectY + (r + 1) * rowHeight;
//                 const left = values[r * 2];
//                 const right = values[r * 2 + 1];

//                 if (left) {
//                     const label = left.inputValue || "";
//                     const slug = left.p_price ? "$" + left.p_price : "N/A";
//                     const labelX = rightRectX + col1 / 2 - 30;
//                     const slugX = rightRectX + col1 + col2 / 2 - 15;
//                     const textY = y - rowHeight / 2 + 2;
//                     doc.setFont("Montserrat-BoldItalic", "bolditalic");
//                     doc.setTextColor(0, 0, 0);
//                     doc.setFontSize(12);
//                     doc.text(label, labelX, textY);
//                     doc.setTextColor(252, 0, 0);
//                     doc.text(slug, slugX, textY);
//                 }

//                 if (right) {
//                     const label = right.inputValue || "";
//                     const slug = right.p_price ? "$" + right.p_price : "N/A";
//                     const labelX = rightRectX + col1 + col2 + col3 / 2 - 30;
//                     const slugX = rightRectX + col1 + col2 + col3 + col4 / 2 - 15;
//                     const textY = y - rowHeight / 2 + 2;
//                     doc.setFont("Montserrat-BoldItalic", "bolditalic");
//                     doc.setTextColor(0, 0, 0);
//                     doc.setFontSize(12);
//                     doc.text(label, labelX, textY);
//                     doc.setTextColor(252, 0, 0);
//                     doc.text(slug, slugX, textY);
//                 }
//             }
//         }

//         // Add horizontal dashed divider between sections on the same page
//         if (sectionsOnThisPage === 2) {
//             const dashY = sectionHeight - 2;
//             doc.setLineDashPattern([10, 5], 0);
//             doc.setDrawColor(0);
//             doc.setLineWidth(1);
//             doc.line(0, dashY, width, dashY);
//             doc.setLineDashPattern([], 0); // Reset dash pattern
//         }

//         // ==========================================
//         // BACK SIDE GENERATION (COLUMN-WISE GRID)
//         // ==========================================
//         if (withBarCode === true) {
//             doc.addPage();

//             doc.setLineDashPattern([10, 5], 0);
//             doc.setDrawColor(0);
//             doc.setLineWidth(1);

//             doc.line(0, height / 2, width, height / 2);
//             doc.line(width / 2, 0, width / 2, height);

//             for (let i = 0; i < sectionsOnThisPage; i++) {
//                 const bannerImgHeight = 0;
//                 const sectionIndex = currentSection + i;
//                 const section = sectionsCount[sectionIndex];

//                 if (!section) continue;

//                 const xPos = (i % 2) * (width / 2) + 2.5;
//                 const yPos = Math.floor(i / 2) * (height / 2) + 2.5;

//                 const rectX = xPos + 2.5;
//                 const rectY = yPos + bannerImgHeight + 5;
//                 const rectW = sectionWidth - 5;
//                 const rectH = sectionHeight - bannerImgHeight - 10;

//                 // ==========================================
//                 // HEADER STYLING: Main Product Name + Perfectly Aligned "Default" Tag
//                 // ==========================================
//                 const mainProductName = (section?.name || "") + " " + "(Bar Codes)";
//                 const badgeText = "Default";

//                 // Set font for name layout calculation
//                 doc.setFont("Montserrat-Bold", "bold");
//                 doc.setFontSize(14);

//                 const nameWidth = doc.getTextWidth(mainProductName);

//                 // Calculate Badge parameters
//                 const badgePaddingX = 8;
//                 const badgePaddingY = 3;
//                 doc.setFontSize(9);
//                 const badgeTextWidth = doc.getTextWidth(badgeText);
//                 const badgeWidth = badgeTextWidth + (badgePaddingX * 2);
//                 const badgeHeight = 12 + (badgePaddingY * 2);

//                 const gapBetweenNameAndBadge = 8;
//                 const totalHeaderWidth = nameWidth + gapBetweenNameAndBadge + badgeWidth;

//                 // Layout Starting coordinates (Centering the entire header block seamlessly)
//                 const startX = rectX + ((rectW - totalHeaderWidth) / 2);
//                 const headerTextY = rectY + 20;


//                 // 1. Draw Main Product Name
//                 doc.setFont("Montserrat-Bold", "bold");
//                 doc.setFontSize(14);
//                 doc.setTextColor(0, 0, 0);
//                 doc.text(mainProductName, startX, headerTextY, { align: "left" });

//                 // 2. Draw "Default" Badge Background
//                 const badgeX = startX + nameWidth + gapBetweenNameAndBadge;
//                 const badgeY = headerTextY - 10.5;

//                 // 4. Solid Underline across the absolute section width
//                 doc.setLineWidth(1);
//                 doc.setDrawColor(0, 0, 0);
//                 doc.setLineDashPattern([], 0);

//                 const underlineY = headerTextY + 12;
//                 doc.line(rectX - 2.5, underlineY, rectX + rectW, underlineY);
//                 // ==========================================

//                 const variations = section?.variations || [];
//                 const groupItems = variations.slice(1);
//                 const individuals = section?.individuals || [];

//                 // Main items dataset
//                 const mainBlock = [
//                     {
//                         value: variations?.[0]?.value,
//                         sku: section?.sku,
//                         price: null,
//                     },
//                     ...groupItems.map(v => ({
//                         value: v?.value,
//                         sku: v?.sku,
//                         price: v?.sale_price,
//                     }))
//                 ];

//                 // Filter individuals: Only include items that contain a valid name AND a valid SKU
//                 const indBlock = individuals
//                     .filter(v => v?.inputValue && v.inputValue.trim() !== "" && v?.sku && v.sku.trim() !== "")
//                     .map(v => ({
//                         value: v?.inputValue,
//                         sku: v?.sku,
//                         price: v?.p_price,
//                     }));

//                 // Unified sequence stream with structural heading insertion logic
//                 const allItems = [...mainBlock];
//                 if (indBlock.length > 0) {
//                     // allItems.push({ isHeading: false, value: "Individual Items" });
//                     allItems.push(...indBlock);
//                 }

//                 const totalItems = allItems.length;

//                 // Skip processing entirely if there are no items to render
//                 if (totalItems === 0) continue;

//                 const columnCount = totalItems > 14 ? 3 : 2;

//                 // Strict alignment threshold rule: 7 entries vertical offset loop breaker
//                 const itemsPerColumn = 7;

//                 const colWidth = (rectW - 10) / columnCount;
//                 const columnsX = Array.from({ length: columnCount }, (_, i) =>
//                     rectX + 5 + i * colWidth
//                 );

//                 // Separate axis Y trackers per lane starting safely below the header underline block
//                 const columnY = Array(columnCount).fill(underlineY + 20);

//                 // Item generation drawing engine
//                 const renderItem = (item, colIndex, globalIndex) => {
//                     const x = columnsX[colIndex];
//                     let y = columnY[colIndex];

//                     if (item.isHeading) {
//                         y += 5; // Extra padding from previous item
//                         doc.setFont("Montserrat-Bold", "bold");
//                         doc.setFontSize(10);
//                         doc.setTextColor(71, 74, 119); // Matches system primary dark blue
//                         doc.text(item.value, x, y);

//                         // Simple text boundary baseline tracker line
//                         const headingWidth = doc.getTextWidth(item.value);
//                         doc.setLineWidth(1);
//                         doc.setDrawColor(71, 74, 119);
//                         doc.line(x, y + 3, x + headingWidth, y + 3);

//                         columnY[colIndex] = y + 18; // Track next sequence offset
//                         return;
//                     }

//                     // --- Variation Label Line ---
//                     doc.setFontSize(8);
//                     doc.setTextColor(0, 0, 0);
//                     doc.text(item.value || "", x, y);

//                     const labelWidth = doc.getTextWidth(item.value || "");

//                     // Add "DEFAULT" Badge right after the main variation value (globalIndex === 0)
//                     if (globalIndex === 0 && item.value) {
//                         const badgeText = "DEFAULT";

//                         doc.setFontSize(5);
//                         const bTextWidth = doc.getTextWidth(badgeText);
//                         const bPaddingX = 2;
//                         const bPaddingY = 1;
//                         const bWidth = bTextWidth + (bPaddingX * 2);
//                         const bHeight = 8 + (bPaddingY * 2);

//                         const bX = x + labelWidth + 4;
//                         const bY = y - 8.5; // Precise baseline offset matching alignment height

//                         // Render filled light gray pill background with a 4px border radius
//                         doc.setFillColor(40, 142, 169);
//                         doc.roundedRect(bX, bY, bWidth, bHeight, 2, 2, 'F');

//                         // Render dark text over pill
//                         doc.setFont("Montserrat-Bold", "bold");
//                         doc.setTextColor(255, 255, 255);
//                         doc.text(badgeText, bX + bPaddingX, bY + 6.4);

//                         // Reset font size back to item value context sizes
//                         doc.setFontSize(8);
//                     }

//                     doc.setTextColor(255, 0, 0);
//                     doc.text(item.price ? `$${item.price}` : "", x + labelWidth + 10, y);

//                     y += 10;

//                     // --- SKU Line ---
//                     doc.setFont("Montserrat-Bold", "bold");
//                     doc.setTextColor(0, 0, 0);
//                     doc.text(item.sku || "", x, y);

//                     if (item.sku) {
//                         const barcodeImg = generateBarcodeBase64(item.sku);
//                         doc.addImage(
//                             barcodeImg,
//                             "PNG",
//                             x,
//                             y,
//                             colWidth - 10,
//                             40
//                         );
//                         y += 35;
//                     }

//                     columnY[colIndex] = y + 20;
//                 };

//                 // Process entire pipeline into columns down the lines vertically first
//                 allItems.forEach((item, index) => {
//                     let colIndex = Math.floor(index / itemsPerColumn);

//                     // RESTRICTION RULE: If this item is a heading AND it's scheduled to land at the 
//                     // very bottom (last index) of a column, force it to the top of the next column instead.
//                     if (item.isHeading && (index % itemsPerColumn === itemsPerColumn - 1)) {
//                         colIndex += 1;
//                     }

//                     const targetCol = colIndex >= columnCount ? columnCount - 1 : colIndex;
//                     renderItem(item, targetCol, index);
//                 });
//             }
//         }

//         currentSection += sectionsOnThisPage;
//     }

//     doc.save(`price-tags_${timestamp}.pdf`);
// };


import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";
import { Url, getAdjustedPrice, generateBarcodeBase64 } from "../../../Services/Api";

import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";



const now = new Date();
const timestamp = now
    .toISOString()           // e.g., "2025-08-15T21:45:30.123Z"
    .replace(/[:.]/g, '-')   // Replace colon and dot with dash
    .replace('T', '_')       // Replace 'T' with underscore
    .split('Z')[0];          // Remove trailing 'Z'


export const generatePDFOpt2 = (sectionsCount, bannerImg, withBarCode) => {
    const width = 816;
    const height = 1056;
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [width, height],
    });

    const sectionHeight = height / 2;
    const sectionWidth = width;
    const bannerImgHeight = 94;
    const maxSectionsPerPage = 2;
    let currentSection = 0;

    while (currentSection < sectionsCount.length) {
        if (currentSection > 0) doc.addPage();

        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

        // ==========================================
        // FRONT SIDE GENERATION
        // ==========================================
        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const yPos = i * sectionHeight;
            const xPos = 2.5;

            const section = sectionsCount[sectionIndex];
            if (!section) continue;

            const productImageUrl = section.image;
            const name = section.name;
            const sku = "Model#" + section.sku;
            const variation = section.variations?.[0] || {};
            const sale_price = variation.sale_price;
            const regular_price = variation.regular_price;
            const variation_value = variation.value;

            const bannerImgWidth = width - 5;
            doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

            const sectionRectY = yPos + bannerImgHeight + 4.8;
            const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);
            const sectionRectX = xPos + 2.5;
            const sectionRectWidth = width / 2.9;

            doc.setLineWidth(2);
            doc.setDrawColor(71, 74, 119);
            doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

            const sectionMainImageX = xPos + sectionRectWidth + 2.5;
            const sectionMainImageWidth = width - (sectionRectWidth + 5);
            const sectionMainImageHeight = 290;
            if (productImageUrl) {
                doc.addImage(productImageUrl, "JPEG", sectionMainImageX + 5, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
            }

            doc.setFont("Montserrat-Bold", "bold");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(14);
            const textX = sectionMainImageX + (sectionMainImageWidth - 15);
            const textY = sectionRectY + 15;
            doc.text(name, textX, textY, { align: 'right' });

            doc.setFontSize(16);
            doc.setFont("helvetica", "normal");
            doc.text(sku, textX, textY + 20, { align: 'right' });

            const lineY = sectionRectY + sectionRectHeight / 4;
            doc.line(sectionRectX, lineY, sectionRectX + sectionRectWidth, lineY);

            const subSection1Width = width / 2.9;
            const wasPriceStartY = yPos;

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(40, 142, 169);
            doc.setFontSize(11);
            const text1Width = doc.getTextWidth(variation_value);
            const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
            doc.text(variation_value, wasPriceStartX1, wasPriceStartY + 120);

            const text2 = "was $" + regular_price;
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(16);
            const text2Width = doc.getTextWidth(text2);
            const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
            doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

            const text3 = "$" + sale_price;
            doc.setFont("Montserrat-Black", "normal");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(50);
            const text3Width = doc.getTextWidth(text3);
            const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
            doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);

            if (section.variations.length > 1) {
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(11);
                doc.text("Group Pricing", xPos + 10, lineY + 20);

                for (let v = 1; v < section.variations.length; v++) {
                    const varItem = section.variations[v];
                    const yOffset = lineY + 20 + v * 20;

                    doc.setFontSize(8);
                    doc.setTextColor(0, 0, 0);
                    doc.text(varItem.value || "N/A", xPos + 10, yOffset);

                    const valueWidth = doc.getTextWidth(varItem.value || "N/A");
                    doc.setTextColor(253, 0, 0);
                    doc.text(`$${varItem.sale_price || "0.00"}`, xPos + 10 + valueWidth + 5, yOffset);
                }
            }

            const gridRectX = xPos + (width / 1.49);
            const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
            const gridRectW = width / 3.1;
            const gridRectH = sectionHeight / 3.75;

            doc.setLineWidth(2);
            doc.setDrawColor(71, 74, 119);
            doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');

            const lineHeight = 15;
            const verticalOffset = (gridRectH - (4 * lineHeight)) / 2;

            const text1_main = "$" + getAdjustedPrice(sale_price).toString();
            const text1_suffix = "/week";

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setFontSize(34);
            const width_main = doc.getTextWidth(text1_main);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(14);
            const width_suffix = doc.getTextWidth(text1_suffix);
            const totalWidth = width_main + width_suffix + 2;
            const textX_g1 = gridRectX + (gridRectW / 2);
            const textY_g1 = gridRectY + verticalOffset;
            const combinedTextX = textX_g1 - (totalWidth / 2);

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(34);
            doc.text(text1_main, combinedTextX, textY_g1);
            doc.setFont("helvetica", "bold");
            doc.setTextColor(61, 124, 157);
            doc.setFontSize(18);
            doc.text(text1_suffix, combinedTextX + width_main + 2, textY_g1);

            doc.setFont("helvetica", "normal");
            doc.setTextColor(151, 68, 131);
            doc.setFontSize(13);
            doc.text("Subject to approval. some restrictions apply", textX_g1, textY_g1 + lineHeight + 12, { align: 'center' });

            doc.setFont("helvetica", "bold");
            doc.setTextColor(136, 194, 87);
            doc.setFontSize(24);
            doc.text("NO CREDIT 0 DOWN", textX_g1, textY_g1 + (3.5 * lineHeight) + 5, { align: 'center' });

            doc.setFont("helvetica", "bold");
            doc.setTextColor(56, 112, 151);
            doc.setFontSize(18);
            doc.text("100 DAYS NO INTEREST", textX_g1, textY_g1 + (5.5 * lineHeight) + 5, { align: 'center' });

            const rightRectX = xPos + (width / 2.83);
            const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
            const rightRectW = width / 3.2;
            const rightRectH = sectionHeight / 3.75;

            doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');

            const col1 = rightRectW * 0.3;
            const col2 = rightRectW * 0.2;
            const col3 = rightRectW * 0.3;
            const col4 = rightRectW * 0.2;
            const rowHeight = rightRectH / 4;

            for (let r = 1; r < 5; r++) {
                const y = rightRectY + r * rowHeight;
                doc.line(rightRectX, y, rightRectX + rightRectW, y);
            }

            const colX1 = rightRectX + col1;
            const colX2 = colX1 + col2;
            const colX3 = colX2 + col3;
            doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH);
            doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH);
            doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH);

            const values = section.individuals || [];
            const itemsPerRow = 2;
            const totalRows = Math.ceil(values.length / itemsPerRow);

            for (let r = 0; r < totalRows; r++) {
                const y = rightRectY + (r + 1) * rowHeight;
                const left = values[r * 2];
                const right = values[r * 2 + 1];

                if (left) {
                    const label = left.inputValue || "";
                    const slug = left.p_price ? "$" + left.p_price : "N/A";
                    const labelX = rightRectX + col1 / 2 - 30;
                    const slugX = rightRectX + col1 + col2 / 2 - 15;
                    const textY = y - rowHeight / 2 + 2;
                    doc.setFont("Montserrat-BoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12);
                    doc.text(label, labelX, textY);
                    doc.setTextColor(252, 0, 0);
                    doc.text(slug, slugX, textY);
                }

                if (right) {
                    const label = right.inputValue || "";
                    const slug = right.p_price ? "$" + right.p_price : "N/A";
                    const labelX = rightRectX + col1 + col2 + col3 / 2 - 30;
                    const slugX = rightRectX + col1 + col2 + col3 + col4 / 2 - 15;
                    const textY = y - rowHeight / 2 + 2;
                    doc.setFont("Montserrat-BoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(12);
                    doc.text(label, labelX, textY);
                    doc.setTextColor(252, 0, 0);
                    doc.text(slug, slugX, textY);
                }
            }
        }

        // Horizontal dashed divider between the 2 front sections
        if (sectionsOnThisPage === 2) {
            const dashY = sectionHeight - 2;
            doc.setLineDashPattern([10, 5], 0);
            doc.setDrawColor(0);
            doc.setLineWidth(1);
            doc.line(0, dashY, width, dashY);
            doc.setLineDashPattern([], 0);
        }

        // ==========================================
        // BACK SIDE GENERATION
        // 2 sections per back page, stacked vertically (full width each)
        // matching the same portrait layout as the front side
        // ==========================================
        if (withBarCode === true) {
            doc.addPage();

            // Dashed horizontal divider between the 2 back sections
            if (sectionsOnThisPage === 2) {
                doc.setLineDashPattern([10, 5], 0);
                doc.setDrawColor(0);
                doc.setLineWidth(1);
                doc.line(0, sectionHeight, width, sectionHeight);
                doc.setLineDashPattern([], 0);
            }

            for (let i = 0; i < sectionsOnThisPage; i++) {
                const sectionIndex = currentSection + i;
                const section = sectionsCount[sectionIndex];
                if (!section) continue;

                // Each section occupies full width, stacked top (i=0) / bottom (i=1)
                const xPos = 2.5;
                const yPos = i * sectionHeight;

                const rectX = xPos;
                const rectY = yPos + 5;
                const rectW = width - 5;
                const rectH = sectionHeight - 10;

                // ==========================================
                // HEADER: Product name + underline
                // ==========================================
                const mainProductName = (section?.name || "") + " (Bar Codes)";

                doc.setFont("Montserrat-Bold", "bold");
                doc.setFontSize(14);
                const nameWidth = doc.getTextWidth(mainProductName);

                const startX = rectX + ((rectW - nameWidth) / 2);
                const headerTextY = rectY + 20;

                doc.setTextColor(0, 0, 0);
                doc.text(mainProductName, startX, headerTextY, { align: "left" });

                doc.setLineWidth(1);
                doc.setDrawColor(0, 0, 0);
                doc.setLineDashPattern([], 0);
                const underlineY = headerTextY + 12;
                doc.line(rectX, underlineY, rectX + rectW, underlineY);

                // ==========================================
                // BUILD ITEM LIST:
                // 1. Main product (default variation)
                // 2. Group variations (variations[1+])
                // 3. Individual products (valid inputValue + sku)
                // ==========================================
                const variations = section?.variations || [];
                const groupItems = variations.slice(1);
                const individuals = section?.individuals || [];

                const mainBlock = [
                    {
                        value: variations?.[0]?.value,
                        sku: section?.sku,
                        price: null,
                    },
                    ...groupItems.map(v => ({
                        value: v?.value,
                        sku: v?.sku,
                        price: v?.sale_price,
                    }))
                ];

                const indBlock = individuals
                    .filter(v => v?.inputValue && v.inputValue.trim() !== "" && v?.sku && v.sku.trim() !== "")
                    .map(v => ({
                        value: v?.inputValue,
                        sku: v?.sku,
                        price: v?.p_price,
                    }));

                const allItems = [...mainBlock, ...indBlock];
                const totalItems = allItems.length;
                if (totalItems === 0) continue;

                // Full-width section: use more columns since we have the whole page width
                const columnCount = totalItems > 14 ? 3 : 2;
                const itemsPerColumn = 7;

                const colWidth = (rectW - 10) / columnCount;
                const columnsX = Array.from({ length: columnCount }, (_, j) =>
                    rectX + 5 + j * colWidth
                );

                const columnY = Array(columnCount).fill(underlineY + 20);

                // ==========================================
                // RENDER EACH ITEM WITH BARCODE
                // ==========================================
                const renderItem = (item, colIndex, globalIndex) => {
                    const x = columnsX[colIndex];
                    let y = columnY[colIndex];

                    if (item.isHeading) {
                        y += 5;
                        doc.setFont("Montserrat-Bold", "bold");
                        doc.setFontSize(10);
                        doc.setTextColor(71, 74, 119);
                        doc.text(item.value, x, y);

                        const headingWidth = doc.getTextWidth(item.value);
                        doc.setLineWidth(1);
                        doc.setDrawColor(71, 74, 119);
                        doc.line(x, y + 3, x + headingWidth, y + 3);

                        columnY[colIndex] = y + 18;
                        return;
                    }

                    // Variation label
                    doc.setFont("Montserrat-Bold", "bold");
                    doc.setFontSize(8);
                    doc.setTextColor(0, 0, 0);
                    doc.text(item.value || "", x, y);

                    const labelWidth = doc.getTextWidth(item.value || "");

                    // DEFAULT badge on the first item only
                    if (globalIndex === 0 && item.value) {
                        const badgeText = "DEFAULT";
                        doc.setFontSize(5);
                        const bTextWidth = doc.getTextWidth(badgeText);
                        const bPaddingX = 2;
                        const bPaddingY = 1;
                        const bWidth = bTextWidth + (bPaddingX * 2);
                        const bHeight = 8 + (bPaddingY * 2);
                        const bX = x + labelWidth + 4;
                        const bY = y - 8.5;

                        doc.setFillColor(40, 142, 169);
                        doc.roundedRect(bX, bY, bWidth, bHeight, 2, 2, 'F');

                        doc.setFont("Montserrat-Bold", "bold");
                        doc.setTextColor(255, 255, 255);
                        doc.text(badgeText, bX + bPaddingX, bY + 6.4);

                        doc.setFontSize(8);
                    }

                    // Price in red, right of label
                    doc.setFontSize(8);
                    doc.setTextColor(255, 0, 0);
                    doc.text(item.price ? `$${item.price}` : "", x + labelWidth + 10, y);

                    y += 10;

                    // --- SKU Line ---
                    doc.setFont("Montserrat-Bold", "bold");
                    doc.setTextColor(0, 0, 0);
                    doc.text(item.sku || "", x, y);

                    // Barcode image
                    if (item.sku) {
                        const barcodeImg = generateBarcodeBase64(item.sku);
                        doc.addImage(
                            barcodeImg,
                            "PNG",
                            x,
                            y,
                            colWidth - 10,
                            40
                        );
                        y += 35;
                    }

                    columnY[colIndex] = y + 20;
                };

                allItems.forEach((item, index) => {
                    let colIndex = Math.floor(index / itemsPerColumn);

                    // If heading lands at last slot of a column, push it to next column
                    if (item.isHeading && (index % itemsPerColumn === itemsPerColumn - 1)) {
                        colIndex += 1;
                    }

                    const targetCol = colIndex >= columnCount ? columnCount - 1 : colIndex;
                    renderItem(item, targetCol, index);
                });
            }
        }

        currentSection += sectionsOnThisPage;
    }

    doc.save(`price-tags_${timestamp}.pdf`);
};